import $ = require('jquery');
import angular = require('angular');
import * as _ from 'lodash';
import * as moment from 'moment';

import { directivesModule } from '../directivesModule';
import '../directivesModule';

import { AccountModel } from '../Models/AccountModel';
import '../Models/AccountModel';

import { AtonixAuthenticationService, AtonixRedirector } from '../Models/model';
import '../Models/model';

import { JobsModel } from '../Models/JobsModel';
import '../Models/JobsModel';

import { FilesModel } from '../Models/FilesModel';
import '../Models/FilesModel';

import { AuthorizationModel, AccessTypeBit } from "../Models/AuthorizationModel";
import "../Models/AuthorizationModel";

class NavBarController implements angular.IController {
	public logo: string;
	public bvTitle: string;

	public appContexts: model.IAppContext[];
	public appContext: model.IAppContext;

	public token: string = "";

	public tabs: any[];
	public tab: any;

	public showAssetTree: boolean;
	public assetTree: boolean;
	public clickAssetTree: () => void;

	public showTimeSlider: boolean;
	public timeSlider: boolean;
	public clickTimeSlider: () => void;

	public showAssetInfoTray: boolean;
	public assetInfoTray: boolean;
	public clickAssetInfoTray: () => void;

	public changeAppContext: (params: any) => void;
	public changeTab: (params: any) => void;

	public preferences: model.IUserPreferences;
	public displayName: string;
	public showAppContextBox: boolean = false;
	public showUserStuff: boolean = false;
	public showTabSelector: boolean = false;
	public showAppContext: boolean = true;

	public newNotifications: boolean = false;
	public showNotificationsBox: boolean = false;
	public notifications: model.INotificationItem[][];
	public showAnnouncement: boolean = false;
	public loading: boolean = false;
	public announcementURL: string = "/MD/home";

	constructor(private $http: angular.IHttpService, private $rootScope: angular.IRootScopeService, private $location: ng.ILocationService, private $uibModal: angular.ui.bootstrap.IModalService, private accountModel: AccountModel, private jobsModel: JobsModel, private filesModel: FilesModel, private atonixAuthenticationService: AtonixAuthenticationService, private atonixRedirector: AtonixRedirector, private authorizationModel: AuthorizationModel) {

		// Attempt to retrieve name attribute from token
		this.atonixAuthenticationService.FriendlyName().then((fn) => {
			if (fn) {
				this.displayName = fn;
			}
			else {
				// Federated user's token may not contain name attribute, retrieve DisplayName from UserInfo API
				// 26-Mar-2021 RMB
				this.accountModel.getUserProfile().then((fn) => {
					// If FirstName or LastName is null or empty, DisplayName will be UserName
					this.displayName = fn.DisplayName;
				});
			}
		});

		//This is essential to setting the user theme. 
		this.accountModel.GetUserPreferences()
			.then((preferences) => {
				this.preferences = preferences;
				this.setTheme(this.preferences.Theme);
			})
			.catch((ex) => {
				console.error('Could not get user preferences.');
			});

		$rootScope.$on('$locationChangeStart', (event: angular.IAngularEvent, toUrl: any, fromUrl: any) => {
			this.catchUnhandledURLChange(event, toUrl, fromUrl);
		});

		this.getNotifications();

		this.authorizationModel.getUIPermissions()
			.then((rights) => {
				if (rights && rights.length > 0) {
					if (rights.filter(r => r.Name === 'UI/TaskCenter/IssuesManagement' && (r.Value & AccessTypeBit.CanView) === AccessTypeBit.CanView).length > 0
						|| rights.filter(r => r.Name === 'UI/TaskCenter/DataExplorer' && (r.Value & AccessTypeBit.CanView) === AccessTypeBit.CanView).length > 0) {

						if (!this.loading) {
							const apps = ["Data Explorer", "Work Management", "Issues Management"];
							const pathArr = window.location.pathname.split("/");
							const page = pathArr[pathArr.length - 1];

							if (apps.indexOf(this.getTitle()) !== -1) {
								if (page == "Issue.html") {
									const iid = $location.search().iid;
									if (iid) {
										this.announcementURL = `/MD/issues/i?iid=${iid}`;
									}
								}
								this.showAnnouncement = true;
							}
						}
					}
				}
			});
	}

	private getNotifications() {
		this.jobsModel.getNotifications().then((notifications) => {
			_.sortBy(notifications, 'CreatedDate');

			this.newNotifications = _.some(notifications, n => n.Viewed == false);

			let newNotifications: model.INotificationItem[][] = [];


			let groupDict: { [key: string]: model.INotificationItem[] } = {};

			for (let n of notifications) {
				if (groupDict[n.NotificationGroupID]) {
					groupDict[n.NotificationGroupID].unshift(n);
				}
				else {
					let g: model.INotificationItem[] = [];
					g.unshift(n);
					groupDict[n.NotificationGroupID] = g;
					newNotifications.unshift(g);
				}
			}

			this.notifications = newNotifications;
		})
	}

	private setTheme(newTheme: string) {
		if (newTheme && newTheme.toLowerCase() === 'light') {
			$('#bvtheme').attr('href', '/Content/bvStylesLight.css');
		}
		else {
			$('#bvtheme').attr('href', '');
		}
	}

	public goToSupport() {
		this.atonixAuthenticationService.GetToken().then((t) => {
			this.token = t;
			if (t) {
				window.open("/Services/api/Account/Training?access_token=" + t, "_blank");
			}
			else {
				console.error("Could not open the support site");
			}
		}).catch((error) => {
			console.error("Could not open the support site.");
		});
	}

	public $doCheck() { }
	public $onChanges(onChangesObj: angular.IOnChangesObject) { }
	public $postLink() {
		$('#bvstyles').after('<link id="bvtheme" href="" rel="stylesheet" />');

		var instanceElement = $('#bvNavBarContainer');

		var appContextElementBackdrop = instanceElement.find('#appContextBoxBackdrop');
		appContextElementBackdrop.detach();
		appContextElementBackdrop.appendTo('body');

		var appContextElement = instanceElement.find('#appContextBox');
		appContextElement.detach();
		appContextElement.appendTo('body');

		var userStuffElement = instanceElement.find('#userStuffBox');
		userStuffElement.detach();
		userStuffElement.appendTo('body');

		var tabSelectorElement = instanceElement.find('#tabSelectorBox');
		tabSelectorElement.detach();
		tabSelectorElement.appendTo('body');

		var notificationsElement = instanceElement.find('#notificationsBox');
		notificationsElement.detach();
		notificationsElement.appendTo('body');
	}

	private getURL(url: string) {
		let location = document.createElement('a');
		location.href = url;

		if (location.host == '') {
			location.href = location.href;
		}
		return location;
	}

	private catchUnhandledURLChange(event: angular.IAngularEvent, toUrl: any, fromUrl: any) {
		//var msg = '$locationChangeStart: "' + event.name + '", from "' + fromUrl + '" to "' + toUrl + '"';
		//console.log(msg);
		var urlDec = decodeURIComponent(toUrl);
		var urlParms = urlDec.split('?');
		if (urlParms.length > 1) {
			urlParms = urlParms[1].split('&');
			var foundAC = undefined;
			for (let i = 0; i < urlParms.length; i++) {
				if (urlParms[i].indexOf('ac=') == 0) {
					foundAC = urlParms[i].split('=')[1];
					break;
				}
			}
			// TJC Aug 2019: this is a hack to fix QuickCapture links (4 of 5) redirecting to Program Navigator Summary page
			var pathName = this.getURL(fromUrl).pathname;
			var pathParts = pathName.split('/');
			if ((pathParts.length > 0) && (pathParts[0].length > 0)) {
				pathName = pathParts[0];            // JIC .pathname doesn't have leading '/' for a particular browser
			}
			else if (pathParts.length > 1) {
				pathName = pathParts[1];				// .pathname has leading '/'
			}
			if (pathName.toLowerCase() === 'quickcapture') {
				console.log('NOT redirecting QuickCapture URL');
				return;
			}
			let currentAC = this.appContext;
			if (foundAC && currentAC && !(foundAC == currentAC.DisplayName || foundAC == currentAC.Name || foundAC == currentAC.AppContextID)) {
				console.log('Forcing app context to "' + foundAC + '"');
				for (let i = 0; i < this.appContexts.length; i++) {
					let ac = this.appContexts[i];
					if (foundAC == ac.DisplayName || foundAC == ac.Name || foundAC == ac.AppContextID) {
						this.clickAppContext(ac);
						break;
					}
				}
			}
		}
	}

	public logout() {
		this.accountModel.logout();
		this.atonixRedirector.RedirectToLogin();
	}


	public clickTab(t: any) {
		if (this.changeTab) {
			this.changeTab({ 'tab': t });
		}
		this.hideEverything();
	}

	public clickAppContext(appContext: model.IAppContext) {
		if (this.changeAppContext) {
			this.changeAppContext({ 'ac': appContext });
		}
		this.hideEverything();
	}

	public hideEverything() {
		this.clickShowAppContextBox(false);
		this.clickShowUserStuffBox(false);
		this.clickShowTabSelector(false);
		this.clickShowNotifications(false);
	}

	public clickShowAppContextBox(show?: boolean) {
		if (show !== undefined) {
			this.showAppContextBox = show;
		}
		else {
			this.showAppContextBox = !this.showAppContextBox;
		}
	}

	public clickShowUserStuffBox(show?: boolean) {
		if (show !== undefined) {
			this.showUserStuff = show;
		}
		else {
			this.showUserStuff = !this.showUserStuff;
		}
	}

	public clickShowTabSelector(show?: boolean) {
		if (show !== undefined) {
			this.showTabSelector = show;
		}
		else if (this.tabs && this.tabs.length > 1) {
			this.showTabSelector = !this.showTabSelector;
		}
	}

	public getTab() {
		var result = '';
		if (this.tab) {
			result = this.tab.DisplayText;
		}
		else {
			result = this.getTitle();
		}
		return result;
	}

	public getTitle() {
		var result: string = '';
		if (this.bvTitle) {
			result = this.bvTitle;
		}
		else if (this.appContext) {
			result = this.appContext.DisplayName || '';
		}
		return result;
	}

	public downloadNotificationFile(notifications: model.INotificationItem[]) {
		var notification = _.find(notifications, n => n.NotificationTypeID == 3);
		if (notification == null) {
			console.log('Nothing to download');
			return;
		}

		this.filesModel.notificationUrl(notification.NotificationGroupID)
			.then(url => {
				let filename = decodeURIComponent(url);
				let link = document.createElement('a');
				document.body.appendChild(link);
				link.style.display = 'none';
				link.href = filename;
				link['download'] = filename;
				link.click();

				setTimeout(() => {
					document.body.removeChild(link);
					URL.revokeObjectURL(filename);
				}, 100);
			});
	}

	public clickShowNotifications(show?: boolean) {
		if (!_.isNil(show)) {
			this.showNotificationsBox = show;
		}
		else {
			this.showNotificationsBox = !this.showNotificationsBox;
		}
		if (this.showNotificationsBox) {
			this.getNotifications();
		}
	}

	public calculateAgo(myDate: Date) {
		let now = moment();
		let d = moment(myDate);
		let duration = moment.duration(now.diff(d));

		let days = duration.asDays();
		if (days > 1) {
			return String(Math.floor(days)) + 'd ago';
		}

		let hours = duration.asHours();
		if (hours > 1) {
			return String(Math.floor(hours)) + 'h ago';
		}

		let minutes = duration.asMinutes();
		if (minutes > 1) {
			return String(Math.floor(minutes)) + 'm ago';
		}

		return 'now';
	}

	public viewed(notification: model.INotificationItem) {
		this.jobsModel.notificationViewed(notification.NotificationGroupID).then(n => {
			this.getNotifications();
		});
	}

}

class NavBarComponent implements angular.IComponentOptions {
	templateUrl: string = '/Common/NavBar/_NavBar.html';
	controller: string = 'NavBarController';
	controllerAs: string = 'navBarVM';
	bindings: any = {
		logo: '<',
		bvTitle: '<',

		appContexts: '<',
		appContext: '<',

		tabs: '<',
		tab: '<',

		showAssetTree: '<',
		assetTree: '<',
		clickAssetTree: '&?',

		showTimeSlider: '<',
		timeSlider: '<',
		clickTimeSlider: '&?',

		showAssetInfoTray: '<',
		assetInfoTray: '<',
		clickAssetInfoTray: '&?',

		changeAppContext: '&?',
		changeTab: '&?',
		showAppContext: '<'
	};
}

directivesModule.controller('NavBarController', ['$http', '$rootScope', '$location', '$uibModal', 'accountModel', 'jobsModel', 'filesModel', 'AtonixAuthenticationService', 'AtonixRedirector', 'authorizationModel', ($http, $rootScope, $location, $uibModal, accountModel, jobsModel, filesModel, AtonixAuthenticationService, AtonixRedirector, authorizationModel) => new NavBarController($http, $rootScope, $location, $uibModal, accountModel, jobsModel, filesModel, AtonixAuthenticationService, AtonixRedirector, authorizationModel)])
directivesModule.component('bvNavigation', new NavBarComponent());


// WEBPACK FOOTER //
// ./Common/NavBar/NavBar.ts